import { useSelector } from 'react-redux';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

// Display-only: the list is filtered + paginated server-side, so a client-side
// sort would only reorder the page you can already see.
const rows = [
    { id: 'client', disablePadding: true, label: 'Client' },
    { id: 'type', disablePadding: false, label: 'Type' },
    { id: 'cohort', disablePadding: false, label: 'Cohort' },
    { id: 'country', disablePadding: false, label: 'Country' },
    { id: 'telegram', disablePadding: false, label: 'TG joined' },
    { id: 'status', disablePadding: false, label: 'Shipping status' },
    { id: 'tracking', disablePadding: false, label: 'Tracking code' },
    // Live carrier state. Reads "—" until auto-tracking has credentials, which
    // is the current state in every environment — so the column is informative
    // rather than empty-looking only once a provider is configured.
    { id: 'carrierStatus', disablePadding: false, label: 'Carrier update' },
];

const MatTableHead = () => {
    const rtl = useSelector((state: { rtl: { direction: string } }) => state.rtl);

    return (
        <TableHead>
            <TableRow>
                {rows.map((row) => (
                    <TableCell key={row.id} align={rtl.direction === 'rtl' ? 'right' : 'left'} padding={row.disablePadding ? 'none' : 'normal'}>
                        {row.label}
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
};

export default MatTableHead;
